<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="lds-ring" v-if="!isLoad">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div class="hotels-content" v-if="isLoad">
                                <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                <div>
                                    <form class="accommodation-staff">
                                        <div>
                                            <h2>Staff Accommodation</h2>
                                          <hr />
                                          <h3 class="subtitle">
                                            <div class="car-icon">
                                              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                                <path d="M10.552 3.22119H6.1145L6.3619 2.604C6.40096 2.50505 6.49732 2.43994 6.60148 2.43994H10.065C10.1692 2.43994 10.2655 2.50505 10.3046 2.604L10.552 3.22119Z" fill="white"/>
                                                <path d="M14.0444 9.98437C14.0261 9.76562 13.9975 9.54687 13.9532 9.33073C13.8907 9.01823 13.5548 8.83333 13.2579 8.94531L11.422 9.64062C10.8829 9.84375 11.0548 10.6771 11.6329 10.6458L13.5522 10.5469C13.8412 10.5312 14.0678 10.2734 14.0444 9.98437ZM6.21362 12.1432H10.4532C10.7891 12.1432 10.7891 11.6224 10.4532 11.6224H6.21362C5.87769 11.6224 5.87769 12.1432 6.21362 12.1432ZM1.823 10.4323C1.823 9.5263 2.01571 8.6302 2.3881 7.80755L2.48185 7.60182L1.94279 7.25807C1.86727 7.21093 1.823 7.1276 1.823 7.03906V6.8151C1.823 6.67187 1.94019 6.55469 2.08341 6.55469H2.97404C3.17456 6.15625 3.40112 5.77083 3.65633 5.40364L4.44539 4.29167C4.68758 3.94792 5.08602 3.74219 5.50789 3.74219H10.9376H11.1589C11.5808 3.74219 11.9792 3.94792 12.2214 4.29167L13.0105 5.40364C13.2657 5.77083 13.4923 6.15625 13.6928 6.55469H14.5834C14.7266 6.55469 14.8438 6.67187 14.8438 6.8151V7.03906C14.8438 7.1276 14.7996 7.21093 14.724 7.25781L14.185 7.60156L14.2787 7.80729C14.6511 8.6302 14.8438 9.52604 14.8438 10.4323V12.4036C14.8438 12.5469 14.7266 12.6641 14.5834 12.6641H2.08341C1.94019 12.6641 1.823 12.5469 1.823 12.4036V10.4323ZM2.62248 9.98437C2.59904 10.2734 2.8256 10.5315 3.11466 10.5469L5.03394 10.6458C5.60946 10.6771 5.78654 9.84375 5.24487 9.64062L3.40894 8.94531C3.11206 8.83333 2.77612 9.01823 2.71362 9.33073C2.66935 9.54687 2.64071 9.76562 2.62248 9.98437ZM13.1876 7.45573L11.3725 4.89323C11.323 4.82552 11.2449 4.78385 11.1589 4.78385H5.50789C5.42196 4.78385 5.34383 4.82552 5.29435 4.89323L3.47925 7.45573H13.1876Z" fill="white"/>
                                                <path d="M3.90625 13.1851V13.9663C3.90625 14.1095 3.78906 14.2267 3.64583 14.2267H2.60417C2.46094 14.2267 2.34375 14.1095 2.34375 13.9663V13.1851H3.90625Z" fill="white"/>
                                                <path d="M14.323 13.1851V13.9663C14.323 14.1095 14.2058 14.2267 14.0626 14.2267H13.0209C12.8777 14.2267 12.7605 14.1095 12.7605 13.9663V13.1851H14.323Z" fill="white"/>
                                              </svg>
                                            </div>
                                            <span>Drivers Accommodation</span>

                                          </h3>
                                        </div>
                                      <div class="accommodation-switch">
                                        <span class="accommodation-switch_label">Accommodation Provided:</span>
                                        <div style="margin-right: 10px">
                                          <ClassicSwitch v-model="accommodation.provided"/>
                                        </div>
                                      </div>
                                      <template v-if="accommodation.provided">
                                        <div>
                                          <div class="label">Private or share based rooms?</div>
                                          <div class="peoplePerRoom">
                                            <div class="radio">
                                              <div class="form-control-group form-control-group--radio">
                                                <label
                                                  class="form-control-radio"
                                                  @click="accommodation.roomType = 'PRIVATE'">
                                                  <input
                                                    type="radio"
                                                    name="activity_radio"
                                                    :checked="accommodation.roomType === 'PRIVATE'"/><span
                                                  class="form-control-radio__box"></span
                                                ><span class="form-control-radio__name"
                                                >Private</span
                                                >
                                                </label>
                                                <label
                                                  class="form-control-radio"
                                                  @click="accommodation.roomType = 'SHARED'">
                                                  <input
                                                    type="radio"
                                                    name="activity_radio"
                                                    :checked="accommodation.roomType === 'SHARED'"/><span
                                                  class="form-control-radio__box"></span
                                                ><span class="form-control-radio__name"
                                                >Shared</span
                                                >
                                                </label>
                                              </div>
                                            </div>
                                            <div class="input-group" v-if="accommodation.roomType === 'SHARED'">
                                              <div>People per room:</div>
                                              <div>
                                                <BasicInput type="number" v-model="accommodation.peoplePerRoom"/>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="switches">
                                          <div class="accommodation-switch accommodation-switch__spaced">
                                            <span class="accommodation-switch_label">Hot water:</span>
                                            <div style="margin-right: 10px">
                                              <ClassicSwitch v-model="accommodation.hotWater"/>
                                            </div>
                                          </div>
                                          <div class="accommodation-switch accommodation-switch__spaced">
                                            <span class="accommodation-switch_label">Wi-Fi:</span>
                                            <div style="margin-right: 10px">
                                              <ClassicSwitch v-model="accommodation.wifi"/>
                                            </div>
                                          </div>
                                          <div class="accommodation-switch accommodation-switch__spaced">
                                            <span class="accommodation-switch_label">A/C:</span>
                                            <div style="margin-right: 10px">
                                              <ClassicSwitch v-model="accommodation.ac"/>
                                            </div>
                                          </div>
                                          <div class="accommodation-switch accommodation-switch__spaced">
                                            <span class="accommodation-switch_label">Fan:</span>
                                            <div style="margin-right: 10px">
                                              <ClassicSwitch v-model="accommodation.fan"/>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="accommodation-switch">
                                          <span class="accommodation-switch_label">Food for the driver is provided:</span>
                                          <div style="margin-right: 10px">
                                            <ClassicSwitch v-model="accommodation.foodProvided"/>
                                          </div>
                                        </div>
                                        <div v-if="accommodation.foodProvided">
                                          <div class="accommodation-select_label">Where food for the drivers provided?</div>
                                          <div class="foodExtraCharge">
                                            <ClassicSelect :selected-item="accommodationFoodSelectedItem" :items="accommodationFoodSelectData" custom-width="20rem" @select-item="(v) => accommodation.foodProvider = v.id"/>
                                            <div class="foodExtraCharge">
                                              <Checkbox label="Extra charged:" v-model="accommodation.foodExtraChargeIncluded"/>
                                              <div
                                                class="form-control-group form-control-group_currency">
                                                <div
                                                  class="form-control-wrap form-control-wrap_with-label form-control-wrap_with-label_low">
                                                  <input type="number"
                                                         class="form-control"
                                                         :disabled="!accommodation.foodExtraChargeIncluded"
                                                         v-model="accommodation.foodExtraCharge"
                                                         @change="isEdit = true">
                                                  <span class="label-inp">$</span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                      <hr />
                                        <div class="edit-rooms__btn-edit edit-rooms__btn-edit_prices">
                                            <button @click="updatePopup = true" type="button" class="btn btn--green">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div class="modal-wrapper" v-if="updatePopup">
                                <div class="modal-backdrop"></div>
                                <div class="modal-inner">
                                    <div class="edit-popup edit-popup--history">
                                        <div class="edit-popup__header">
                                            <div class="edit-popup__title">
                                                Update History
                                            </div>
                                            <div class="edit-popup__close" @click="updatePopup = false">
                                                <svg width="1em" height="1em" class="icon icon-close ">
                                                    <use
                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                </svg>
                                            </div>
                                        </div>
                                        <form action="javascript:void(0)" class="edit-popup__inner">
                                            <div class="form-control-group"><span
                                                class="form-control-label">Hi {{
                                                    user ? user.data.firstName : ''
                                                }}, <span> what have you updated?</span> </span>
                                                <div class="form-control-wrap">
                                                    <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                                </div>
                                              <div class="edit-popup__error-text">
                                                <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                              </div>
                                            </div>
                                            <div class="options-additional__btns">
                                                <button type="button" class="btn btn--silver"
                                                        @click="updatePopup = false">
                                                    <span>Cancel</span>
                                                </button>
                                                <button type="submit" class="btn btn--green edit-popup__submit"
                                                        :disabled="descriptionUpdate.length < 6"
                                                        @click="fetchDriverAccommodations">
                                                    <span>Update</span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Lightpick from 'lightpick'
import {
  getHotelAdvanced,
  getHotelsDriverAccommodations,
  putDriverAccommodations,
} from '@/utilites/api'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'
import ClassicSwitch from '@/components/UI/Switch/ClassicSwitch.vue'
import ClassicSelect from '@/components/UI/ClassicSelect/ClassicSelect.vue'
import Input from '@/components/UI/Inputs/BasicInput.vue'
import BasicInput from '@/components/UI/Inputs/BasicInput.vue'
import Checkbox from '@/components/UI/Checkbox/Checkbox.vue'

export default {
  components: {Checkbox, BasicInput, Input, ClassicSelect, ClassicSwitch, HotelsSideMenu},
    data() {
        return {
            copyPopup: false,
            updatePopup: false,
            copyPopupFrom: '',
            copyPopupOpen: false,
            descriptionUpdate: '',
            year: new Date().getFullYear(),
            isEdit: false,
            hotelName: '',
            hotelChainId: null,
            isLoad: false,
            description: '',
            data: {years: []},
            accommodation: {
              "provided": false,
              "level": "BASIC",
              "roomType": "PRIVATE",
              "peoplePerRoom": 0,
              "hotWater": false,
              "wifi": false,
              "ac": false,
              "fan": false,
              "foodProvided": false,
              "foodProvider": "MAIN_RESTAURANT",
              "foodExtraChargeIncluded": false,
              "foodExtraCharge": 0
            },
          accommodationFoodSelectData: [
            {id: 'MAIN_RESTAURANT', name: 'Main Restaurant'},
            {id: 'STAFF_AREA', name: 'Staff Area'},
          ],
        }
    },
    props: ['user'],
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id).then(res => {
            this.hotelName = res.names.EN
            this.hotelChainId = res.chainId
        })
    },
    mounted() {
        this.updateData()
    },
  computed: {
    accommodationFoodSelectedItem() {
      return this.accommodationFoodSelectData.find(i => i.id === this.accommodation.foodProvider);
    }
  },
    methods: {
        fetchDriverAccommodations() {
              putDriverAccommodations(this.normalizeDataDriverAccommodation(), this.$route.params.id)
                    .then(() => {
                        this.updateData()
                        this.$emit('confirmed')
                        this.updatePopup = false
                        this.descriptionUpdate = ''
                        this.isEdit = false
                    })
        },
      normalizeDataDriverAccommodation() {
        return{
          accommodation: {
            ...this.accommodation,
            foodExtraCharge: this.accommodation.foodExtraChargeIncluded ? this.accommodation.foodExtraCharge : 0,
            peoplePerRoom: this.accommodation.roomType === 'SHARED' ? this.accommodation.peoplePerRoom : 0,
            foodProvider: this.accommodation.foodProvided ? this.accommodation.foodProvider : null,
          },
          history: {
            hotelId: +this.$route.params.id,
            userId: this.user.data.id,
            description: this.descriptionUpdate
          }
        }
      },
        updateData() {
            Promise.all([getHotelsDriverAccommodations(this.$route.params.id)])
                .then(res => {
                  this.accommodation = res[0];
                    this.isLoad = true
                })
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                        datePicker.hide()
                    })
                });
            }, 1000)
        },

        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
    }
}
</script>
<style lang="scss" scoped>
.accommodation-staff {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

.label {
  font-size: 12px;
}

.subtitle {
  font-size: 12px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 6px;
}

hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #DADADA;
  margin: 16px 0;
  padding: 0;
}
.accommodation-switch {
  display: flex;
  gap: 12px;
  align-items: center;

  &_label {
    font-size: 12px;
  }

  &__spaced {
    justify-content: space-between;
  }
}
.accommodation-select {
  &_label {
    font-size: 12px;
    margin-bottom: 6px;
  }
}

.radio {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 5px;
}

.input-group {
  display: flex;
  gap: 12px;
  align-items: center;
  font-size: 12px;
}

.peoplePerRoom {
  display: flex;
  gap: 22px;
  align-items: center;
  height: 36px;
}

.switches {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 140px;
}

.foodExtraCharge {
  display: flex;
  align-items: center;
  gap: 12px;
}

.car-icon {
  background: #2E2E2E;
  border-radius: 100%;
  width: 21px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>